var _defineProperty = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/defineProperty.js").default;
var _CN, _JP;
module.exports = {
  messages: {
    CN: (_CN = {
      'productList.hint': '温馨提示',
      'productList.lastSynchronizedStockTime': '上次同步ERP库存时间',
      'productList.productName': '商品名称',
      'productList.enterPlease': '请输入',
      'productList.productNo': '商品编号',
      'productList.productCategory': '商品分类',
      'productList.skuNo': 'SKU编号',
      'productList.sellPrice': '售价',
      'productList.activityPrice': '活动价',
      'productList.pointMultiple': '积分倍数',
      'productList.stockNum': '库存数量',
      'productList.choiceDays': '备货天数',
      'productList.shelfTime': '上架时间',
      'productList.createTime': '创建时间',
      'productList.productStatus': '状态',
      'productList.all': '全部',
      'productList.onTheShelf': '上架',
      'productList.offTheShelf': '下架',
      'productList.onTheShelfSuccessfully': '上架成功',
      'productList.offTheShelfSuccessfully': '下架成功',
      'productList.transportMode': '运输方式',
      'productList.requestDelivery': '要求配送',
      'productList.yes': '是',
      'productList.no': '否',
      'productList.brand': '品牌',
      'productList.deliveryChannel': '发货渠道',
      'productList.sourceArea': '原产地',
      'productList.ERPSynchronizedStockSwitch': 'ERP库存同步',
      'productList.productBelong': '仕入类型',
      'productList.other': '他社',
      'productList.self': '自社',
      'productList.open': '是',
      'productList.close': '否',
      'productList.outOfStock': '低库存商品',
      'productList.query': '查询',
      'productList.export': '导出',
      'productList.closeUp': '收起',
      'productList.openDown': '展开',
      'productList.addCategory': '追加分类',
      'productList.addButton': '新增'
    }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CN, "productList.sellPrice", '售价'), 'productList.taxIncluded', '(含税)'), 'productList.copy', '复制'), 'productList.commentList', '评论列表'), 'productList.productImage', '商品图片'), 'productList.updateTime', '更新时间'), 'productList.operation', '操作'), 'productList.specsName', '规格名称'), 'productList.chooseProductCategory', '请选择商品分类'), 'productList.chooseProduct', '请选择商品'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CN, 'productList.rate', '税率值'), 'productList.noInnerData', '暂无规格'), 'productList.selfStocknum', '足立仓库库存'), 'productList.otherStocknum', '货源仓库库存'), "newProductList", {
      'srx': '仕入先',
      'visitorVisible': '游客可见性',
      'goodsGrouped': '商品分组',
      'noVisible': '不可见',
      'visible': '可见',
      'overSell': '终卖',
      'specification': '规格名称',
      'createTimeErp': '创建时间(ERP)',
      'editVisible': '编辑商品可见性设置',
      'overshellSuccess': '终卖成功',
      'rongliang': '容量',
      'sureOver': '确定要终卖吗？',
      'productSync': '同步商品信息'
    })),
    JP: (_JP = {
      'productList.hint': 'ヒント',
      'productList.lastSynchronizedStockTime': '前回ERP在庫同期時刻',
      'productList.productName': '商品名',
      'productList.enterPlease': '入力してください',
      'productList.productNo': '商品コード',
      'productList.productCategory': '商品分類',
      'productList.skuNo': 'SKU编号',
      'productList.sellPrice': '販売価格',
      'productList.activityPrice': '活动价',
      'productList.pointMultiple': '积分倍数',
      'productList.stockNum': '在庫数',
      'productList.choiceDays': '在庫補充日数',
      'productList.shelfTime': '販売開始時間',
      'productList.createTime': '作成時間',
      'productList.productStatus': '状態',
      'productList.all': '全部',
      'productList.onTheShelf': '販売開始',
      'productList.offTheShelf': '販売停止',
      'productList.onTheShelfSuccessfully': '販売開始しました',
      'productList.offTheShelfSuccessfully': '販売停止しました',
      'productList.transportMode': '配達方法',
      'productList.requestDelivery': '要求配送',
      'productList.yes': 'はい',
      'productList.no': 'いいえ',
      'productList.brand': 'ブランド',
      'productList.deliveryChannel': '发货渠道',
      'productList.sourceArea': '原産地',
      'productList.ERPSynchronizedStockSwitch': 'ERP在庫同期',
      'productList.productBelong': '仕入れ種別',
      'productList.other': '他社',
      'productList.self': '自社',
      'productList.open': 'はい',
      'productList.close': 'いいえ',
      'productList.outOfStock': '低库存商品',
      'productList.query': '検索',
      'productList.export': 'エクスポート',
      'productList.closeUp': '閉じる',
      'productList.openDown': '展開',
      'productList.addCategory': '追加分类',
      'productList.addButton': '追加'
    }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JP, "productList.sellPrice", '販売価格'), 'productList.taxIncluded', '（税込）'), 'productList.copy', 'コピー'), 'productList.commentList', '评论列表'), 'productList.productImage', '商品画像'), 'productList.updateTime', '更新時間'), 'productList.operation', '操作'), 'productList.specsName', '規格名'), 'productList.chooseProductCategory', '商品カテゴリーを選択してください'), 'productList.chooseProduct', '商品を選択してください'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JP, 'productList.rate', '税率'), 'productList.noInnerData', '規格なし'), 'productList.selfStocknum', '足立仓库库存'), 'productList.otherStocknum', '货源仓库库存'), "newProductList", {
      'srx': '仕入先',
      'visitorVisible': 'ゲスト閲覧',
      'goodsGrouped': '商品グループ',
      'noVisible': '閲覧不可',
      'visible': '閲覧可',
      'overSell': '終売',
      'specification': '規格名',
      'createTimeErp': '作成時間(ERP)',
      'editVisible': '商品の可視性設定の編集',
      'overshellSuccess': '終売しました',
      'rongliang': '容量',
      'sureOver': '确定要终卖吗？',
      'productSync': '商品情報を同期する'
    }))
  }
};